import React from 'react';
import { useTheme } from 'styled-components';
import { SetOptional } from 'type-fest';
import { AvatarButton } from 'components/Avatar';
import Divider from 'components/Divider';
import Menu, { MenuProps } from 'components/Menu';
import AccountMenuHeader from './AccountMenuHeader';

export interface AccountMenuProps extends SetOptional<MenuProps, 'button'> {
  /**
   * User's email address for display in the header of the menu
   */
  emailAddress: string;
}

/**
 * A component for showing a user account menu.  This menu is typically located
 * on the right side of a header.
 *
 * See `Menu` for adding items to the `AccountMenu`.
 */
const AccountMenu: React.FC<AccountMenuProps> = ({
  emailAddress,
  ...props
}) => {
  const theme = useTheme();

  return (
    <Menu
      button={<AvatarButton initial={emailAddress.charAt(0)} />}
      density="default"
      header={
        <>
          <AccountMenuHeader emailAddress={emailAddress} />
          <Divider color={theme.palette.l4} gutter={16} space={0} />
        </>
      }
      offset={10}
      placement="bottom end"
      {...props}
    />
  );
};
export default AccountMenu;
